import { render, staticRenderFns } from "./SummaryCardContent.vue?vue&type=template&id=0b23963a&scoped=true&"
import script from "./SummaryCardContent.vue?vue&type=script&lang=js&"
export * from "./SummaryCardContent.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCardContent.vue?vue&type=style&index=0&id=0b23963a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b23963a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VTooltip})
